import React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App.js";
import "./styles.css";
import { LanguageProvider } from "./i18n/LanguageContext.js";
import { AppStateProvider } from "./state/AppStateContext.js";

createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <LanguageProvider>
      <AppStateProvider>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </AppStateProvider>
    </LanguageProvider>
  </React.StrictMode>
);
